module.exports = __webpack_public_path__ + "static/media/large-garden.0e4f2276.jpg";